export const formatCurrency = (amount: string | number | undefined, currency: string = 'EUR', locale?: string): string => {
    if (amount === null || amount === undefined || amount === '') return '';

    // Convert to number and check if it's valid
    const num = typeof amount === 'string' ? parseFloat(amount) : amount;
    if (isNaN(num)) return String(amount);

    // Determine locale - default to German, but allow override
    const formatLocale = locale || 'de-DE';

    // Format with thousand separator and 2 decimal places
    return new Intl.NumberFormat(formatLocale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(num);
};

// Helper function to get locale from language
export const getLocaleFromLanguage = (language: string): string => {
    if (language.startsWith('en')) return 'en-US';
    if (language.startsWith('de')) return 'de-DE';
    return 'de-DE'; // Default fallback
};
